import { BaseModule } from '@/modules/common.module';
import { GenerateItemDescriptionResponse } from '@/models/ai.models';
import { ApiResponseBase } from '@/models/common.models';
import { Organization, GenerateItemDescriptionRequest } from '@/api';

export class AiModule extends BaseModule {
  constructor(organizationId: Organization['id']) {
    super(`v1/organizations/${organizationId}/ai`);
  }

  async generateItemDescription(
    data: GenerateItemDescriptionRequest
  ): Promise<GenerateItemDescriptionResponse> {
    const response = await this.post<GenerateItemDescriptionResponse>(
      `generate-item-description`,
      data
    );
    return response.data;
  }

  async proxy<T>(
    url: string,
    data: {
      method: 'GET' | 'POST' | 'PUT' | 'DELETE';
      headers?: Record<string, string>;
      body?: unknown;
      queryParams?: Record<string, string>;
    }
  ): Promise<{
    status: number;
    headers: Record<string, string>;
    output: T | undefined; // in case of error
  }> {
    // extract query params from url
    const urlParts = url.split('?');
    const urlWithoutQueryParams = urlParts[0];
    const queryParams = urlParts[1]
      ? Object.fromEntries(new URLSearchParams(urlParts[1]).entries())
      : {};

    const response = await this.post<
      ApiResponseBase<{
        headers: Record<string, string>;
        status: number;
        output: T | undefined;
      }>
    >(`proxy`, {
      url: urlWithoutQueryParams,
      ...data,
      queryParams: {
        ...queryParams,
        ...data.queryParams,
      },
    });

    return response.data.data;
  }
}
